var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomOut = function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 37"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".zoom-out_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zoom-out_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zoom-out_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.56 34.44-7.2-7.2a16.63 16.63 0 1 0-2.12 2.12l7.2 7.2a1.5 1.5 0 0 0 2.12 0 1.49 1.49 0 0 0 0-2.12M3 16.61a13.61 13.61 0 1 1 23.26 9.59A13.6 13.6 0 0 1 3 16.61",
    className: "zoom-out_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.28 15.11H10.94a1.5 1.5 0 1 0 0 3h11.34a1.5 1.5 0 0 0 0-3",
    className: "zoom-out_svg__cls-1"
  })))));
};
export default SvgZoomOut;